
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_1aoom_44",
  "checkbox-control": "awsui_checkbox-control_k2y2q_1aoom_77",
  "outline": "awsui_outline_k2y2q_1aoom_93"
};
  